import { render, staticRenderFns } from "./SimpleCalculation.vue?vue&type=template&id=492883da&"
import script from "./SimpleCalculation.vue?vue&type=script&lang=ts&"
export * from "./SimpleCalculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports